var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v("Message")]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "content"
  }, [_vm.active == 0 ? _c("van-swipe-cell", {
    scopedSlots: _vm._u([{
      key: "right",
      fn: function fn() {
        return [_c("van-button", {
          staticClass: "delete-button",
          attrs: {
            square: "",
            text: "删除",
            type: "danger"
          }
        })];
      },
      proxy: true
    }], null, false, 3880173695)
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "showArea"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v("Vehicle Alarm")]), _c("span", {
    staticClass: "right"
  }, [_vm._v("2 minutes ago")])]), _c("div", {
    staticClass: "bottom"
  }, [_vm._v("Your vehicle networking is not activated, please contact the MG Dealer to activate.")])])])]) : _vm._e(), _vm.active == 3 ? _c("div", [_c("div", {
    staticClass: "notice",
    on: {
      click: function click($event) {
        return _vm.toPage("Likes");
      }
    }
  }, [_c("div", {
    staticClass: "left-wrap"
  }, [_vm._m(0), _c("div", {
    staticClass: "likes"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Likes")]), _vm.likedData.count ? _c("span", {
    staticClass: "bottom"
  }, [_vm._v("You have a new like.")]) : _vm._e()])]), _c("div", {
    staticClass: "right-wrap"
  }, [_c("span", {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(_vm.likedData.created_at))]), _vm.likedData.count ? _c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.likedData.count))]) : _vm._e()])]), _c("div", {
    staticClass: "notice",
    on: {
      click: function click($event) {
        return _vm.toPage("Comments");
      }
    }
  }, [_c("div", {
    staticClass: "left-wrap"
  }, [_vm._m(1), _c("div", {
    staticClass: "likes"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v(_vm._s(_vm.$t("Comments")))]), _vm.repliedData.count ? _c("span", {
    staticClass: "bottom"
  }, [_vm._v("You have a new comments.")]) : _vm._e()])]), _c("div", {
    staticClass: "right-wrap"
  }, [_c("span", {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(_vm.repliedData.created_at))]), _vm.repliedData.count ? _c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.repliedData.count))]) : _vm._e()])]), _c("div", {
    staticClass: "notice",
    on: {
      click: function click($event) {
        return _vm.toPage("Dynamic");
      }
    }
  }, [_vm._m(2), _vm._m(3)])]) : _vm._e()], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "img-wrap"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Likes@2x.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "img-wrap"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Comments@3x.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "left-wrap"
  }, [_c("div", {
    staticClass: "img-wrap"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Dynamic@2x.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "likes"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Dynamic")]), _c("span", {
    staticClass: "bottom"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "right-wrap"
  }, [_c("span", {
    staticClass: "minutes"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };